module.exports = __webpack_public_path__ + "img/empty.c53241dd.png";